module.exports = require("@angular/platform-browser");


//////////////////
// WEBPACK FOOTER
// external "@angular/platform-browser"
// module id = 87
// module chunks = 0